import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["value"]

import { useStore } from "vuex";
import { computed } from "vue";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoundedRectangleDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'rounded-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );
const useIndividualCorners = computed(
	() => store.getters["rounded-rectangle/useIndividualCorners"]
);

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const length = computed({
	get: () => dimensions.value.length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "length",
			value: value,
		});
	},
});

const radius = computed({
	get: () => dimensions.value.radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "radius",
			value: value,
		});
	},
});

const topRightRadius = computed({
	get: () => dimensions.value.top_right_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "top_right_radius",
			value: value,
		});
	},
});

const bottomRightRadius = computed({
	get: () => dimensions.value.bottom_right_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "bottom_right_radius",
			value: value,
		});
	},
});

const bottomLeftRadius = computed({
	get: () => dimensions.value.bottom_left_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "bottom_left_radius",
			value: value,
		});
	},
});

const topLeftRadius = computed({
	get: () => dimensions.value.top_left_radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "top_left_radius",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "rounded-rectangle-length",
        id: `${_ctx.prefix}measurements-rounded-rectangle-length`,
        name: `${_ctx.prefix}measurements[dimensions][length]`,
        unit: "cm",
        label: dimensionLabel.value('width', 'rounded-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}rounded-rectangle-length`),
        onBlur: () => _unref(addSizeToDataLayer)('length', +length.value, 'rounded-rectangle'),
        modelValue: length.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((length).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "rounded-rectangle-width",
        id: `${_ctx.prefix}measurements-rounded-rectangle-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('height', 'rounded-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}rounded-rectangle-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'rounded-rectangle'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      (useIndividualCorners.value === false)
        ? (_openBlock(), _createBlock(DimensionInput, {
            key: 0,
            inputRef: "rounded-rectangle-radius",
            id: "measurements-rounded-rectangle-radius",
            name: "measurements[dimensions][radius]",
            unit: "cm",
            label: dimensionLabel.value('radius', 'rounded-rectangle'),
            invalid: !isDimensionValid.value('rounded-rectangle-radius'),
            onBlur: () => _unref(addSizeToDataLayer)('radius', +radius.value, 'rounded-rectangle'),
            modelValue: radius.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((radius).value = $event))
          }, null, 8, ["label", "invalid", "onBlur", "modelValue"]))
        : _createCommentVNode("", true),
      (useIndividualCorners.value)
        ? (_openBlock(), _createBlock(DimensionInput, {
            key: 1,
            inputRef: "rounded-rectangle-top_left_radius",
            id: "measurements-rounded-rectangle-top_left_radius",
            name: "measurements[dimensions][top_left_radius]",
            unit: "cm",
            label: dimensionLabel.value('top_left_radius', 'rounded-rectangle'),
            invalid: !isDimensionValid.value('rounded-rectangle-top_left_radius'),
            onBlur: 
				() =>
					_unref(addSizeToDataLayer)(
						'top_left_radius',
						+topLeftRadius.value,
						'rounded-rectangle'
					)
			,
            modelValue: topLeftRadius.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((topLeftRadius).value = $event))
          }, null, 8, ["label", "invalid", "onBlur", "modelValue"]))
        : _createCommentVNode("", true),
      (useIndividualCorners.value)
        ? (_openBlock(), _createBlock(DimensionInput, {
            key: 2,
            inputRef: "rounded-rectangle-top_right_radius",
            id: "measurements-rounded-rectangle-top_right_radius",
            name: "measurements[dimensions][top_right_radius]",
            unit: "cm",
            label: dimensionLabel.value('top_right_radius', 'rounded-rectangle'),
            invalid: !isDimensionValid.value('rounded-rectangle-top_right_radius'),
            onBlur: 
				() =>
					_unref(addSizeToDataLayer)(
						'top_right_radius',
						+topRightRadius.value,
						'rounded-rectangle'
					)
			,
            modelValue: topRightRadius.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((topRightRadius).value = $event))
          }, null, 8, ["label", "invalid", "onBlur", "modelValue"]))
        : _createCommentVNode("", true),
      (useIndividualCorners.value)
        ? (_openBlock(), _createBlock(DimensionInput, {
            key: 3,
            inputRef: "rounded-rectangle-bottom_left_radius",
            id: "measurements-rounded-rectangle-bottom_left_radius",
            name: "measurements[dimensions][bottom_left_radius]",
            unit: "cm",
            label: dimensionLabel.value('bottom_left_radius', 'rounded-rectangle'),
            invalid: !isDimensionValid.value('rounded-rectangle-bottom_left_radius'),
            onBlur: 
				() =>
					_unref(addSizeToDataLayer)(
						'bottom_left_radius',
						+bottomLeftRadius.value,
						'rounded-rectangle'
					)
			,
            modelValue: bottomLeftRadius.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((bottomLeftRadius).value = $event))
          }, null, 8, ["label", "invalid", "onBlur", "modelValue"]))
        : _createCommentVNode("", true),
      (useIndividualCorners.value)
        ? (_openBlock(), _createBlock(DimensionInput, {
            key: 4,
            inputRef: "rounded-rectangle-bottom_right_radius",
            id: "measurements-rounded-rectangle-bottom_right_radius",
            name: "measurements[dimensions][bottom_right_radius]",
            unit: "cm",
            label: dimensionLabel.value('bottom_right_radius', 'rounded-rectangle'),
            invalid: !isDimensionValid.value('rounded-rectangle-bottom_right_radius'),
            onBlur: 
				() =>
					_unref(addSizeToDataLayer)(
						'bottom_right_radius',
						+bottomRightRadius.value,
						'rounded-rectangle'
					)
			,
            modelValue: bottomRightRadius.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bottomRightRadius).value = $event))
          }, null, 8, ["label", "invalid", "onBlur", "modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        ref: "rounded-rectangle-use_individual_corners",
        type: "hidden",
        name: "measurements[modifiers][use_individual_corners]",
        key: "rounded-rectangle-use_individual_corners",
        value: useIndividualCorners.value
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})